import React from "react";
import { stateChangeText } from "@/components/dashboard/BuyerRequestsCard";
import { diffFields, fieldLabel } from "@/components/BuyerCriteriaRequestsPanel";

const STATUS = {
  pending: ["Waiting", "border-amber-800 bg-amber-100 text-amber-900"],
  approved: ["Approved", "border-emerald-800 bg-emerald-100 text-emerald-900"],
  rejected: ["Rejected", "border-rose-800 bg-rose-100 text-rose-900"],
};

function RequestRow({ r }) {
  const [label, tone] = STATUS[r.status] || [r.status, "border-zinc-800 bg-zinc-100"];
  const states = stateChangeText(r);
  const others = diffFields(r.current_criteria_snapshot, r.proposed_criteria).filter((d) => d.key !== "accepted_states").map((d) => fieldLabel(d.key));
  return (
    <div className="border-b border-zinc-200 p-3 last:border-b-0" data-testid={`buyer-request-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2 text-[11px]">
        <span className={`border px-1.5 py-0.5 text-[9px] uppercase tracking-widest ${tone}`} data-testid={`buyer-request-status-${r.id}`}>{label}</span>
        <span className="font-mono text-zinc-500">Sent {new Date(r.created_at).toLocaleDateString()}</span>
        {r.reviewed_at && <span className="font-mono text-zinc-500">· {label} {new Date(r.reviewed_at).toLocaleDateString()}</span>}
      </div>
      {states && <div className="mt-1 text-sm font-semibold" data-testid={`buyer-request-states-${r.id}`}>{states}</div>}
      {others.length > 0 && <div className="mt-0.5 text-[11px] text-zinc-700">{states ? "Also changes" : "Changes"}: {others.join(", ")}</div>}
      {r.notes && <div className="mt-0.5 text-[11px] text-zinc-600">Your note: {r.notes}</div>}
      {r.status === "pending" && <div className="mt-1 text-[11px] text-zinc-500">Waiting for your account manager to review it.</div>}
      {r.review_notes && (
        <div className={`mt-1.5 border-l-4 p-2 text-xs ${r.status === "rejected" ? "border-rose-500 bg-rose-50" : "border-emerald-500 bg-emerald-50"}`} data-testid={`buyer-request-reason-${r.id}`}>
          <b>{r.status === "rejected" ? "Reason" : "Note from your account manager"}:</b> {r.review_notes}
        </div>
      )}
    </div>
  );
}

// The buyer's own criteria requests: waiting, approved or rejected, with the reason.
export function BuyerRequestHistory({ requests }) {
  if (!requests.length) return null;
  return (
    <div className="mt-3 border border-black" data-testid="buyer-my-requests">
      {requests.slice(0, 8).map((r) => <RequestRow key={r.id} r={r} />)}
    </div>
  );
}
